export const DEFAULT_EXCEL_TABLE_STYLE = "TableStyleMedium2"